import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import './CustomerChoice.css';
import RadioButton from "../common/radioButton/RadioButton";
import RegulationAcceptance from "../regulationAcceptance/RegulationAcceptance";
import { getCustomer, setCustomerType } from "../../features/customer/customerSlice";
import { setComplaintType, setCreatedDate, setIsTermOfUseAccepted } from '../../features/complaint/ComplaintSlice';
import { getComplaint, setSelectClient, setSelectComplaintType } from "../../features/complaintTypes/ComplaintTypesSlice";   
import moment from 'moment';

const CustomerChoice = ({ isChoiceCompanySelected, onChoiceSelected, isChoiceSelected }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const complaintTypes = useSelector((state) => state.complaintTypes.complaintTypes);
    const [selectedOption, setSelectedOption] = useState(null);
    const [currentPage, setCurrentPage] = useState(window.location.pathname);
    const isTermOfUseAccepted = useSelector((state) => state.complaint.isTermOfUseAccepted);
    const selectedClient = useSelector((state) => state.complaintTypes.selectedClient);
    const privatePersonType = useSelector((state) => state.customer.type[2]);

    useEffect(() => {
        dispatch(getComplaint());
        dispatch(getCustomer());
    }, [dispatch]);

    const handleGetComplaintType = (event) => {
        const complaintType = event.target.value;
        dispatch(setSelectComplaintType(complaintType));
        dispatch(getComplaint(complaintType));
    };

    const handleOptionClick = async (option) => {
        dispatch(getComplaint(option.name));
        setSelectedOption(option.displayName);
        setSelectClient(selectedClient);
        dispatch(setComplaintType({
            id: option.id,
            name: option.complaintType,
            displayName: option.displayName
        }));

        

        if (privatePersonType) {
            dispatch(setCustomerType({
             
                    id: privatePersonType.customerId,
                    displayName: privatePersonType.displayName,
                    customerType: privatePersonType.customerType,
                    description: privatePersonType.description,
                    value: privatePersonType.name
                
            }));
        }


        if (!isChoiceSelected) {
            onChoiceSelected("CustomerChoice");
        }

        dispatch(setCreatedDate(moment()));
    };

    useEffect(() => {
        function handlePageChange() {
            setCurrentPage(window.location.pathname);
        }
        window.addEventListener("popstate", handlePageChange);
        return () => {
            window.removeEventListener("popstate", handlePageChange);
        };
    }, [currentPage]);

    const handleFormSubmit = async (event) => {
        event.preventDefault();
    };

    const validateForm = () => {
        if (isTermOfUseAccepted && selectedOption) {
            setCurrentPage('information');
            navigate('/information');
        }
    };

    return (
        <div className='individual-customer-container' onClick={handleGetComplaintType} onSubmit={handleFormSubmit}>
            <div className='individual-customer-container-title-container'>
                <h5>klient indywidualny</h5>
                <p style={{ fontSize: '14px', textTransform: 'none', fontWeight: 'normal' }}>(osoba nie prowadząca działalności gospodarczej)</p>
            </div>
            <div className='individual-customer-type-list-container'>
                <p className='individual-customer-type-list-container-title'>Możesz zgłosić:</p>
                {Object.values(complaintTypes).filter(customer => customer.customerId === 1)
                    .map(customer => 
                        customer.complaintTypes.map(option => (
                            <div className='individual-customer-list-element-container' key={option.id}>
                                <li style={{ listStyle: 'none', cursor: 'pointer', display: 'inline-flex' }}>
                                    <RadioButton
                                        id={option.id}
                                        name={option.name}
                                        value={option.displayName}
                                        onClick={() => handleOptionClick(option)}
                                        checked={selectedOption === option.displayName && !isChoiceCompanySelected}
                                    />
                                    <p className="individual-customer-list-element-text" onClick={() => handleOptionClick(option)}>
                                        {option.displayName}
                                    </p>
                                </li>
                            </div>
                        ))
                    )
                }
                {selectedOption && !isChoiceCompanySelected &&
                    <>
                        <div>
                                            <RegulationAcceptance checked={isTermOfUseAccepted} selectedOption={selectedOption} complaintTypes={complaintTypes} selectedClient={selectedClient}/>
                                            <button className="add-complaint-btn" type="submit" onClick={validateForm}><p>Dodaj zgłoszenie</p></button>
                                        </div>
                                        <br></br>
                                        </>
                                        } 
     
                </div>
            </div>
    )
}

export default CustomerChoice;